import TrashCan from './src/trash-can-combined';
export default TrashCan;